<div>
  <div>
    <!-- <label class="autocomplete-label"
           #typeahead
           [ngClass]="{'display--xxl-none': result.length < 0 || backspace === true , 'display--xxl-flex': result.length > 1}"
           for="autocomplete"><span class="font-grey">{{before}}</span><span class="font-orange">{{type_ahead}}</span><span
            class="font-grey">{{after}}</span></label> -->
    <input
            type="text"
            appDebounce
            #inputfield
            [(ngModel)]="type_ahead"
            autocomplete="new-password"
            [placeholder]="placeholder"
            (keyup.arrowdown)="get_next_result($event)"
            (keydown.arrowdown)="$event.preventDefault(); $event.stopPropagation()"
            (keyup.arrowup)="get_prev_results($event)"
            (keydown.arrowup)="$event.preventDefault()"
            (keydown.Tab)="take_value($event)"
            (keyup.arrowright)="take_value($event)"
            (keyup.enter)="take_value($event); $event.stopPropagation()"
            (keydown.enter)="$event.preventDefault()"
            (keyup.backspace)="backspace_alert()"
            (keyup.esc)="return_old_value()"
            (focus)="remove_placeholder()"
            (blur)="take_value($event)"
            (click)="remove_placeholder()"
            (keyup)="type_results()"
            [style.width]="inputWidth + 'rem'"
            class="autocomplete-input font--xxl-13 {{ inputStyle }}"
            [ngClass]="{
        'border-grey': !exsisting_value || exsisting_value === '' || isDisabled,
        'border-blue-full-input': exsisting_value && exsisting_value !== '' && !isDisabled
      }"
            [readOnly]="isDisabled"
    />
    <div
      #results
      *ngIf="type_ahead && result?.length > 0"
      class="autocomplete-results border--left-grey border--right-stroke"
      [style.width]="containerWidth + 'rem'"
      [ngClass]="{ 'border--bottom-grey': result.length > 0 }"
    >
      <div
        *ngFor="let obj of result; let i = index"
        class="flex align-items-center justify-content-start autocomplete-results--result padding-xxl--top-4 padding-xxl--bottom-4 border--bottom-grey"
        id="selresult{{ i }}"
        [ngClass]="{ 'background-grey': sel === i, 'font-orange': sel === i }"
      >
        <div
          [ngClass]="{ 'background-grey': sel === i, 'font-orange': sel === i }"
          class="flex align-items-center autocomplete-results--result-inner font--xxl-13 font-body-text padding-xxl--left-18 padding-xxl--right-5 text-hover edited"
          (mouseenter)="sel = i"
          (click)="take_value($event)"
        >
          {{ obj[objectValue] | slice: 0:40 }}{{ obj[objectValue]?.length > 40 ? '...' : '' }}
        </div>
      </div>
    </div>
  </div>
</div>
